export default __webpack_public_path__ + "assets/bg_service_announcement_p.jpg";